import { i18n } from "..";

export enum TravelSportActivitiesEnum {
  AMATEUR = 'amateur',
  PROFESSIONAL = 'professional',
  NONE = 'none'
}

export const TravelSportActivitiesEnumLabel = {
  [TravelSportActivitiesEnum.AMATEUR]: i18n.t('common.constants.travelSportActivities.amateur'),
  [TravelSportActivitiesEnum.PROFESSIONAL]: i18n.t('common.constants.travelSportActivities.professional'),
  [TravelSportActivitiesEnum.NONE]: i18n.t('common.constants.travelSportActivities.none')
}